export enum EntityType {
  TENANT = 'TENANT',
  TENANT_PROFILE = 'TENANT_PROFILE',
  CUSTOMER = 'CUSTOMER',
  USER = 'USER',
  DASHBOARD = 'DASHBOARD',
  ASSET = 'ASSET',
  DEVICE = 'DEVICE',
  DEVICE_PROFILE = 'DEVICE_PROFILE',
  ASSET_PROFILE = 'ASSET_PROFILE',
  ALARM = 'ALARM',
  RULE_CHAIN = 'RULE_CHAIN',
  RULE_NODE = 'RULE_NODE',
  EDGE = 'EDGE',
  ENTITY_VIEW = 'ENTITY_VIEW',
  WIDGETS_BUNDLE = 'WIDGETS_BUNDLE',
  WIDGET_TYPE = 'WIDGET_TYPE',
  API_USAGE_STATE = 'API_USAGE_STATE',
  TB_RESOURCE = 'TB_RESOURCE',
  OTA_PACKAGE = 'OTA_PACKAGE',
  RPC = 'RPC',
  QUEUE = 'QUEUE',
  ATTRIBUTE = 'ATTRIBUTE',
  AUDIT_LOG = 'AUDIT_LOG',
  HUB_INFO = 'HUB_INFO',
  PANEL = 'PANEL',
  DEVICE_INFO = 'DEVICE_INFO',
  ENTITY_GROUP = 'ENTITY_GROUP',
  ALIAS = 'ALIAS',
  NOTIFICATION = 'NOTIFICATION',
  NOTIFICATION_TARGET = 'NOTIFICATION_TARGET',
  NOTIFICATION_TEMPLATE = 'NOTIFICATION_TEMPLATE',
  NOTIFICATION_DISPATCH = 'NOTIFICATION_DISPATCH',
  SESSION = 'SESSION',
  ALARM_COMMENT = 'ALARM_COMMENT',
  API_KEY = 'API_KEY',
}
